import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { beforeAfter } from '../data/salesCopy';
export function BeforeAfterSection() {
  return <section className="bg-brand-ivoryLight px-4 py-8 sm:py-10" data-id="element-22" data-mp="poby570o2pvy">
      <div className="mx-auto max-w-4xl" data-id="element-23" data-mp="ppn154maftm0">
        <SectionTitle data-id="element-24" data-mp="kwtuucb68d7t">{beforeAfter.heading}</SectionTitle>

        <p className="mt-4 text-center text-[13px] font-semibold text-brand-charcoal/85 sm:text-[15px]" data-id="element-25" data-mp="kv8zwlky2s9f">
          {beforeAfter.intro}
        </p>

        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-26" data-mp="ulty47wphurt">
          <div className="rounded-lg border border-brand-clay/50 bg-white p-3" data-id="element-27" data-mp="18mo7asrkvzrj">
            <h3 className="text-[13px] font-extrabold uppercase tracking-widest text-brand-clay sm:text-sm" data-id="element-28" data-mp="18kk4yf9bv8td">
              Today:
            </h3>
            <ul className="mt-2 space-y-1" data-id="element-29" data-mp="3ad81k5rguy06">
              {beforeAfter.today.map(line => <li key={line} className="flex items-start gap-1.5 text-[12.5px] font-medium leading-snug text-brand-charcoal/75 sm:text-[13.5px]" data-id="element-30" data-mp="35fgdjmtxzw19">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-clay" aria-hidden="true" data-id="element-31" data-mp="3bmth3tefo33y" />
                  {line}
                </li>)}
            </ul>
          </div>

          <div className="rounded-lg border-2 border-brand-sage bg-brand-sage/5 p-3" data-id="element-32" data-mp="3lfiqmiqfb6wn">
            <h3 className="text-[13px] font-extrabold uppercase tracking-widest text-brand-sage sm:text-sm" data-id="element-33" data-mp="3perkdnlgr4s7">
              Tomorrow:
            </h3>
            <ul className="mt-2 space-y-1" data-id="element-34" data-mp="379sx8smdavr">
              {beforeAfter.tomorrow.map(line => <li key={line} className="flex items-start gap-1.5 text-[12.5px] font-semibold leading-snug text-brand-charcoal sm:text-[13.5px]" data-id="element-35" data-mp="87flcr6pr1ew">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-36" data-mp="29xr2qcahaucc" />
                  {line}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-4 space-y-1 text-center text-[13px] font-extrabold uppercase leading-snug text-brand-sage sm:text-[15px]" data-id="element-37" data-mp="1x0uksx7x3x9l">
          {beforeAfter.close.map(line => <p key={line} data-id="element-38" data-mp="26yqxhtgi709t">{line}</p>)}
        </div>
      </div>
    </section>;
}